export class RapumRapportiniUm {
    rapumId: number;
    rapumMisId: number;
    rapumRapId: number;
    rapumUm: string;
    rapumQta: number;
    rapumCodArticolo: string;
    rapumDescrizione: string;
}